/**
 * Duplicates slides inside the Swiper container.
 *
 * @param {string} containerClass - CSS class of the Swiper container without a dot (e.g., “gallery-swiper-wr”)
 * @param {number} count - How many times to duplicate each slide.
 *
 * @example
 * duplicateSwiperSlides("gallery-swiper-wr", 2);
 */

export function duplicateSwiperSlides(containerClass, count) {
  const containers = document.querySelectorAll(`.${containerClass}`);

  containers.forEach(container => {
    const slides = container.querySelectorAll('.swiper-slide');
    const swiperWrapper = container.querySelector('.swiper-wrapper');

    if (!swiperWrapper || slides.length === 0) return;

    for (let i = 0; i < count; i++) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        swiperWrapper.appendChild(clone);
      });
    }
  });
}